import { render, staticRenderFns } from "./TaxReturnResult.vue?vue&type=template&id=af8007e0&scoped=true&"
import script from "./TaxReturnResult.vue?vue&type=script&lang=ts&"
export * from "./TaxReturnResult.vue?vue&type=script&lang=ts&"
import style0 from "./TaxReturnResult.vue?vue&type=style&index=0&id=af8007e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af8007e0",
  null
  
)

export default component.exports